<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="290">
      <v-card light>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text>{{ text }}</v-card-text>
        <v-card-actions>
          <v-btn color="error" flat @click="dialog = false">Cancelar</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="submit">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    functionYes: Function,
    text: {
      type: String,
      default: '¿Seguro que desea continuar?'
    },
    title: {
      type: String,
      default: 'Confirmación'
    }
  },

  data () {
    return {
      dialog: false
    }
  },

  methods: {
    openDialog () {
      this.dialog = true
    },
    submit () {
      this.dialog = false
      this.functionYes()
    }
  }
}
</script>
